import feedbackTrainersList from '@/store/modules/feedback-trainers/feedback-trainers-list'
import feedbackTrainersInfo from '@/store/modules/feedback-trainers/feedback-trainers-info'

export default {
  feedbackTrainersList,
  feedbackTrainersInfo,
}
